import React, { useEffect, useState } from "react";
import { API_URL, UPLOADS_API_URL } from "./config";
import { Row, Col, Card, Spinner, Alert, Form } from "react-bootstrap";
import { motion } from "framer-motion";
import XGolifeDashboardComponent from "./components/XGolifeDashboardComponent";

import { Link } from "react-router-dom"; // Import Link for navigation

const Report = () => {
  return (
    <XGolifeDashboardComponent>
      <div style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
            <div>
                <h1 style={{marginTop: 20, marginBottom: 20}}>Reports</h1>
                <div className="d-flex flex-column align-items-center">
              <Link
                to="/OnlineStoreDailyReports"
                className="btn btn-primary mb-4"
                style={{ width: "200px" }}
              >
                Daily Sales Report
              </Link>
              <Link
                to="/WeeklySalesReports"
                className="btn btn-primary mb-4"
                style={{ width: "200px" }}
              >
                Weekly Sales Report
              </Link>
              <Link
                to="/MonthlySalesReports"
                className="btn btn-primary mb-4"
                style={{ width: "200px" }}
              >
                Monthly Sales Report
              </Link>
            </div>
            </div>
        </div>
    </XGolifeDashboardComponent>
  );
};

export default Report;
